export default {
  app: {
    title: '纽科莱·集装箱管理系统 (TMS)',
    brand: 'BrazilTMS',
    brandDesc: '纽科莱海运全生命周期管理平台',
    brtTime: '巴西利亚时间 (GMT-3)'
  },
  login: {
    title: '系统登录',
    demo: 'TMS',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    captcha: '验证码',
    captchaPlaceholder: '请输入验证码',
    captchaLoading: '加载中...',
    captchaFailed: '验证码获取失败，请刷新重试',
    captchaImage: '验证码',
    submit: '登 录',
    loginFailed: '登录失败，请重试',
    admin: {
      name: '总部财务 / 超级管理员',
      desc: '录入发货 · 管理运输 · 入库核销 · 导出报表 · 历史回滚',
      badge: '全部权限'
    },
    cargo: {
      name: '巴西物流仓储专员',
      desc: '到港确认 · 配送时间 · 仓库清点 · 异常留痕 · 上传图片',
      badge: '操作权限'
    },
    hint: '纽科莱·集装箱管理系统',
    langLabel: '语言'
  },
  nav: {
    dashboard: '仪表板',
    shipmentImport: '采购录入',
    statusBoard: '状态看板',
    storageManagement: '入库管理',
    userManagement: '用户管理',
    roleManagement: '角色管理',
    transitValue: '在途货值大盘',
    monthlyForecast: '月度到港预测',
    reports: '报表导出',
    timelineAnalysis: '时效分析',
    profile: '个人中心',
    overview: '概览',
    importDesc: '新建集装箱',
    manageDesc: '查看与处理',
    valueDesc: '实时资产监控',
    forecastDesc: 'ETA预测分析',
    reportDesc: '数据导出',
    timelineDesc: '供应链效率KPI'
  },
  dashboard: {
    totalOrders: '总集装箱',
    statusDistribution: '数据统计',
    shipping: '已启运',
    arrived: '已到港',
    pendingDelivery: '待派送',
    warehouse: '海外仓处理',
    completed: '已完结',
    recentOrders: '数据列表',
    latest5: '最新 5 条',
    inTransitValue: '在途货值',
    timelineKpi: '时效指标',
    transitValuePanel: {
      title: '在途总货值',
      realtime: '实时',
      inTransit: '在途总货值',
      delayed: '延迟在途',
      inventory: '转为库存资产',
      completed: '标准完结资产',
      containerUnit: '柜',
      standard: '标准运输',
      progress: '运输进度',
      lastUpdate: '实时更新',
      trendUp: '上涨',
      trendDown: '下降',
      trendNeutral: '平稳'
    },
    forecastPanel: {
      title: '月度预计到港预测',
      container: '预计到港集装箱',
      total: '共',
      items: '条',
      clickView: '点击查看',
      clickRefresh: '查看最新数据',
      loading: '加载中...',
      selectMonth: '选择月份'
    },
    actions: {
      detail: '详情',
      items: '装箱明细'
    },
    table: {
      index: '序号',
      container: '集装箱标准编码',
      containerNo: '箱号',
      billNo: '提单号',
      originPort: '启运港',
      receivingCompany: '收货公司',
      totalValue: '货值',
      eta: 'ETA',
      etd: 'ETD',
      ata: 'ATA',
      status: '状态',
      actions: '操作',
      internalCabinetNo: '内部柜号'
    },
    chart: {
      count: '数量',
      percentage: '占比',
      resetFilter: '重置筛选',
      placeholder: '预留位置（用于例外图表）'
    },
    trendChart: {
      title: '月度到港趋势',
      forecast: '预计到港',
      actual: '实际到港',
      unit: '柜',
      selectYear: '选择年份'
    }
  },
  status: {
    shipping: '已启运',
    arrived: '已到港',
    pending_delivery: '待派送',
    warehouse: '海外仓处理',
    completed: '已完结',
    shippingDesc: '中国采购/国内仓录入',
    arrivedDesc: '确认到港捕获ATA',
    pendingDesc: '清关完等待拖车提柜',
    warehouseDesc: '线上线下双轨核销',
    completedDesc: '数据锁定归档'
  },
  shipment: {
    import: '采购录入',
    longCode: '集装箱标准编码输入框',
    longCodePlaceholder: '粘贴长编码，如: C-20260512-2-NINGBO-B232113464-YMMU6235123-311-MAXIMO',
    parseCode: '解析编码',
    parsedFields: '编码解析结果',
    identifier: '固定前缀',
    loadingDate: '装柜日期',
    shift: '班次/批次号',
    originPort: '启运港',
    billNo: '海运提单号 (BL)',
    containerNo: '集装箱箱号',
    internalCabinetNo: '公司内部柜号',
    receivingCompany: '巴西收货公司',
    totalValue: '集装箱总货值 (BRL)',
    totalValuePlaceholder: '请输入总货值（巴西雷亚尔）',
    eta: '预计到港时间 (ETA)',
    etd: '预计船期 (ETD)',
    etaPlaceholder: '选择预计到港日期',
    etdPlaceholder: '选择预计发船日期',
    submit: '保存并生成卡片',
    submitSuccess: '集装箱卡片生成成功',
    codeFormatError: '编码格式不符合规范，请检查分隔符或参数完整性',
    codeSegmentError: '编码段格式错误',
    allRequired: '请填写所有必填字段（总货值、ETA）',
    customsClearanceTime: '清关完成时间',
    deliveryTime: '配送时间（拖车提柜时间）',
    deliveryTimePlaceholder: '选择拖车实际提柜/出发时间',
    recordATA: '确认到港 (录入ATA)',
    ataPlaceholder: '选择实际到港时间',
    skuTitle: '装箱明细 (Packing List)',
    skuAdd: '+ 添加商品明细',
    skuCode: '产品型号 (SKU)',
    skuBoxes: '箱数',
    skuQty: '总数量',
    skuPrice: '单价 (BRL)',
    skuRemark: '备注',
    skuRemove: '删除',
    skuRequired: '请至少添加1条装箱明细',
    importXlsx: '导入xlsx',
    recent: '最近提交',
    records: '单',
    table: {
      containerNo: '箱号',
      billNo: '提单号',
      originPort: '启运港',
      receivingCompany: '收货公司',
      totalValue: '货值',
      shipDate: '发货日期',
      eta: 'ETA',
      status: '状态',
      actions: '操作',
      detail: '详情'
    }
  },
  shipmentImport: {
    importing: '正在导入...',
    parseSuccess: '解析成功',
    remark: '备注',
    remarkPlaceholder: '请输入备注信息（可选）',
    confirmTitle: '确认创建集装箱',
    systemCode: '集装箱唯一系统编码',
    internalCabinetNo: '内部柜号',
    receivingCompany: '收货公司',
    totalValue: '总货值',
    codeAnalysisTitle: '编码自动拆解规则协议',
    identifier: '标识',
    loadingDate: '装柜日期',
    shift: '批次号',
    originPort: '启运港',
    billNo: '提单号',
    containerNo: '国际箱号',
    packingDetail: '装箱明细',
    sku: 'SKU',
    ctns: '箱数',
    pcsPerCtn: '每箱件数',
    qty: '总数量',
    unitPrice: '单价',
    totalAmount: '总金额',
    total: '总计',
    note: '备注',
    confirmHint: '确认以上信息无误后，点击"确认创建"按钮提交。系统将自动创建集装箱记录。',
    cancel: '取消',
    creating: '创建中...',
    confirmCreate: '确认创建',
    codeEmptyError: '编码不能为空',
    parseCodeFirst: '请先解析长编码',
    enterTotalValue: '请填写总货值',
    selectEta: '请选择ETA日期',
    selectEtd: '请选择ETD日期',
    createFailed: '创建失败',
    createFailedRetry: '创建失败，请稍后重试',
    invalidFileType: '请选择 .xlsx 或 .xls 格式的文件',
    importSuccess: '导入成功',
    importFailedCheck: '导入失败，请检查文件格式',
    importFailedRetry: '导入失败，请稍后重试',
    downloadTemplate: '下载模板',
    deleteConfirm: '确定删除该集装箱吗？删除后不可恢复！'
  },
  warehouse: {
    title: '海外仓卸货核销',
    erpStockedIn: 'ERP系统已入库（线上库存上架完成）',
    warehouseChecked: '仓库已卸货清点完成（线下实体理货完成）',
    abnormalCheck: '货物状态 *',
    abnormal: '有异常 (Com Anomalia)',
    normal: '无异常 (Sem Anomalia)',
    abnormalType: '清点异常备注 *',
    abnormalTypePlaceholder: '请详细描述现场破损或丢件情况...',
    uploadImage: '现场照片上传 *',
    uploadRequired: '⚠️ 无论有无异常，必须上传至少1张现场照片',
    abnormalRequired: '⚠️ 请确认货物有无异常',
    erpLocked: 'ERP入库由管理员/财务操作',
    confirm: '完成核销并归档',
    confirmSuccess: '双轨核销完成，集装箱已自动完结归档',
    imageCount: '已上传 {count} 张图片',
    dropHere: '拖拽图片到此处或点击上传'
  },
  transitValue: {
    title: '今日在途总货值大盘',
    totalInTransit: '在途总货值',
    unit: 'BRL',
    containerCount: '在途集装箱数',
    containerUnit: '柜',
    description: '资产唯一判定标准：【ERP系统已入库】复选框未勾选。无论货在海上还是仓里，全额算在途资产。',
    dynamicDeduction: '在状态四勾选ERP入库瞬间，大盘总货值立刻自动扣减该箱金额，资产转为在库库存。',
    notVisibleCargo: '此模块仅对管理员/财务角色开放',
    stockedInValue: '已入库总货值',
    completedAssets: '已完结资产',
    containerList: '在途货柜清单',
    stockedIn: '已入库',
    notStockedIn: '未入库',
    erpStockInBtn: 'ERP入库',
    erpStockInSuccess: 'ERP入库确认成功，在途货值已自动扣减',
    table: {
      containerNo: '箱号',
      billNo: '提单号',
      goodsValue: '货值 (BRL)',
      status: '状态',
      erpStatus: 'ERP入库',
      actions: '操作',
      billNoLabel: '提单号:',
      goodsValueLabel: '货值:',
      erpLabel: 'ERP:'
    }
  },
  monthlyForecast: {
    title: '月度预计到港预测（仓储空间前置规划）',
    selectMonth: '选择月份',
    allMonths: '全部月份',
    predictionList: '预测集装箱列表',
    etaEmpty: 'ATA待填',
    noPrediction: '暂无预计到港集装箱',
    rule: '抓取规则：ETA属于选定月份 且 ATA为空。一旦录入ATA，毫秒级从列表中剔除。',
    table: {
      containerNo: '箱号',
      billNo: '提单号',
      eta: '预计到港',
      originPort: '启运港',
      goodsValue: '货值',
      status: '状态'
    }
  },
  reports: {
    title: '报表导出',
    exportFull: '导出完整报表 (Excel)',
    exportCargoList: '导出装箱清单 (无价格)',
    exportTransit: '导出在途货物明细表 (Excel)',
    adminOnly: '仅管理员可用',
    desensitized: '清单已自动剔除单价与总货值列',
    exportSuccess: '报表导出成功',
    fullDesc: '包含所有字段：箱号、提单号、启运港、收货公司、货值、ETA、ATA、清关时间、配送时间、ERP状态、异常信息',
    cargoListDesc: '不含单价与总货值列 - 适用于货物人员现场理货',
    transitDesc: '仅导出状态为在途（尚未完结/未入库）的货物明细数据',
    dataPreview: '数据预览',
    records: '条记录',
    customsClearanceTime: '清关时间',
    deliveryTime: '配送时间',
    noDataExport: '暂无数据可导出',
    exportSuccessMsg: '导出成功',
    exportFailed: '导出失败',
    networkError: '网络错误'
  },
  statusBoard: {
    export: '导出',
    exportExcel: '导出excel',
    download: '下载数据',
    newContainer: '新建集装箱',
    createTitle: '新建集装箱',
    pasteCode: '粘贴长编码（自动解析并反向填充字段）',
    codeExample: '示例: C - 20260512 - 2 - NINGBO - B232113464 - YMMU6235123 - 311 - MAXIMO',
    codeFormatHint: '编码格式: 标识符 - 装柜日期 - 班次 - 启运港 - 提单号 - 箱号 - 内部柜号 - 收货公司',
    codeFormatError: '编码格式不符合规范，请检查分隔符或参数完整性。',
    autoParsedFields: '自动解析字段（不可编辑）',
    manualFields: '手动补全核心字段',
    skuItems: '装箱明细（SKU）',
    noSkuItems: '暂无装箱明细',
    addSkuItem: '添加商品明细',
    saveCreate: '保存并创建',
    search: {
      containerNo: '箱号',
      internalCabinetNo: '内部柜号',
      totalValue: '货值',
      receivingCompany: '收货公司',
      placeholderContainerNo: '搜索箱号',
      placeholderInternalCabinetNo: '搜索内部柜号',
      placeholderTotalValue: '搜索货值',
      placeholderReceivingCompany: '搜索收货公司'
    },
    sort: {
      eta: '按ETA排序',
      value: '按货值排序',
      date: '按装柜日期排序'
    },
    table: {
      containerNo: '箱号',
      internalCabinetNo: '内部柜号',
      receivingCompany: '收货公司',
      totalValue: '货值',
      eta: 'ETA',
      etd: 'ETD',
      ata: 'ATA',
      shippingRemark: '启运备注',
      shippingImage: '启运图片',
      deliveryRemark: '配送备注',
      arrivalTime: '到港时间',
      completedTime: '完结时间',
      actions: '操作',
      warehouseChecked: '清点',
      abnormal: '异常',
      hasAbnormal: '有异常',
      noAbnormal: '无异常'
    },
    actions: {
      confirmArrival: '确认到港',
      detail: '详情',
      items: '装箱明细',
      rollback: '回滚'
    },
    status: {
      completed: '已完结',
      readOnly: '只读'
    },
    modal: {
      analysisTitle: '编码解析内容',
      internalCabinetNo: '柜号',
      shift: '班次/批次号',
      billNo: '提单号',
      containerNo: '集装箱号',
      originPort: '启运港',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      confirmArrivalHint: '确认此集装箱已到达港口，系统将自动记录当前时间为实际到港时间（ATA）。',
      customsClearanceLabel: '输入核心时效参数：【清关完成时间】(必填)',
      customsClearancePlaceholder: '选择清关完成时间',
      deliveryLabel: '输入核心车辆调度参数：【配送时间】(必填)',
      deliveryPlaceholder: '选择配送时间',
      erpStockedIn: 'ERP系统已入库',
      warehouseChecked: '仓库已卸货清点完成',
      adminDisabled: '管理员不可选',
      inspectionResult: '现场理货结果判定:',
      noAbnormal: '无异常',
      hasAbnormal: '有异常',
      uploadPhotos: '📸 上传现场卸货/空柜留痕照片 (必传)',
      uploadHint: '💡 必须选择至少1张留痕照片方可保存成功',
      uploadOptional: '💡 图片上传为可选，用于记录到港情况',
      clickPreview: '点击预览大图',
      uploadPlaceholder: '📸 点击上传图片',
      abnormalRemark: '清点差异异常具体备注 (必填)',
      abnormalPlaceholder: '请详细描述现场破损或丢件情况...',
      erpStocked: 'ERP入库',
      warehouseCount: '仓库清点',
      completedLocked: '🔒 当前处于历史数据锁定状态，不允许非超级管理员进行反核销。',
      cancel: '取消',
      confirmArrival: '确认到港',
      saveUpdate: '保存更新并触发流转',
      completed: '已完成',
      pending: '⏳ 待处理',
      completedSuccess: '✅ 已完成',
      rollback: '到港撤销',
      rollbackConfirm: '确定要撤销到港状态并返回待确认状态吗？此操作将清空清关时间等相关数据。',
      rollbackSuccess: '撤销成功',
      shippingRemark: '启运备注',
      modify: '修改',
      shippingRemarkPlaceholder: '请输入启运备注信息（可选）',
      shippingRemarkImages: '启运备注图片',
      deliveryRemark: '派送备注',
      deliveryRemarkPlaceholder: '请输入派送备注信息（可选）',
      remarkTitle: '备注管理',
      noRemarkContent: '请输入备注内容或上传图片',
      uploadSuccess: '图片上传成功',
      title: {
        shipping: '集装箱流转工作台',
        arrived: '集装箱流转工作台 — 录入清关完成时间',
        pending_delivery: '集装箱流转工作台 — 录入配送时间',
        warehouse: '集装箱流转工作台 — 海外仓双轨核销',
        completed: '集装箱流转工作台 — 已完结锁定'
      }
    },
    containerUnit: '柜',
    create: {
      identifier: '标识符',
      loadingDate: '装柜日期',
      loadingDateExample: '例如：2026-07-20',
      shift: '班次',
      batchNo: '班次/批次',
      batchNoExample: '例如：1',
      originPort: '启运港',
      departurePort: '启运港',
      departurePortExample: '例如：SHA',
      billNo: '提单号',
      blNo: '海运提单号',
      blNoExample: '例如：BL20260727001',
      containerNo: '箱号',
      internalCabinetNo: '内部柜号',
      receivingCompany: '收货公司',
      totalValue: '集装箱总货值',
      enterValue: '请输入货值',
      etd: '预计船期（ETD）',
      eta: '预计到港时间（ETA）',
      etdExample: '例如：2026-07-09',
      etaExample: '例如：2026-07-09',
      shipDate: '发货日期',
      shipDateExample: '例如：2026-07-28'
    },
    sku: {
      delete: '删除',
      sku: '产品型号',
      skuPlaceholder: '型号',
      ctns: '箱数',
      ctnsPlaceholder: '箱数',
      pcsPerCtn: '每箱件数',
      pcsPerCtnPlaceholder: '件/箱',
      qty: '总数量',
      unitPrice: '单价',
      unitPricePlaceholder: '单价',
      totalAmount: '总金额',
      note: '备注',
      notePlaceholder: '备注',
      autoCalc: '自动计算'
    },
    actionButtons: {
      audit: '审核处理',
      verify: '核销处理'
    }
  },
  containerDetail: {
    title: '集装箱详情',
    basicInfo: '集装箱基本信息',
    items: '装箱明细',
    exportItems: '导出装箱清单',
    exportFull: '导出完整清单',
    close: '关闭',
    noItems: '暂无装箱明细',
    missingId: '缺少集装箱ID',
    loadFailed: '加载数据失败，请稍后重试',
    containerNo: '箱号',
    internalCabinetNo: '内部柜号',
    blNo: '提单号',
    departurePort: '启运港',
    receivingCompany: '收货公司',
    loadingDate: '装柜日期',
    status: '状态',
    totalValue: '总货值',
    customsClearanceTime: '清关时间',
    deliveryTime: '配送时间',
    erpChecked: 'ERP入库',
    warehouseChecked: '仓库清点',
    remark: '备注',
    anomalyRemark: '异常备注',
    abnormalImages: '海外仓图片',
    ctns: '箱数',
    pcsPerCtn: '每箱件数',
    qty: '总数量',
    unitPrice: '单价',
    totalAmount: '总金额',
    total: '总计',
    note: '备注',
    checked: '已勾选',
    unchecked: '未勾选',
    editTimes: '修改时间',
    editTimesTitle: '修改时间信息',
    selectEtd: '选择ETD日期',
    selectEta: '选择ETA日期',
    selectAta: '选择ATA日期',
    cancel: '取消',
    save: '保存',
    updateSuccess: '时间信息更新成功',
    updateFailed: '时间信息更新失败',
    images: '现场照片',
    shippingRemark: '启运备注',
    deliveryRemark: '派送备注'
  },
  userManagement: {
    title: '系统用户管理',
    subtitle: '管理用户账号与权限分配',
    addUser: '新增用户',
    searchUsername: '搜索用户名...',
    allStatus: '全部状态',
    normal: '正常',
    disabled: '禁用',
    query: '查询',
    reset: '重置',
    userId: '用户ID',
    username: '用户名',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    status: '状态',
    role: '角色',
    createTime: '创建时间',
    actions: '操作',
    edit: '编辑',
    assignRole: '分配角色',
    resetPassword: '重置密码',
    enable: '启用',
    disable: '禁用',
    delete: '删除',
    noData: '暂无用户数据',
    noDataTip: '点击右上角“新增用户”开始创建',
    addUserTitle: '新增用户',
    editUserTitle: '编辑用户',
    confirmPassword: '确认密码',
    cancel: '取消',
    confirmSubmit: '确认提交',
    assignRoleTitle: '分配角色',
    saveRole: '保存角色',
    resetPasswordTitle: '重置密码',
    newPassword: '新密码',
    password: '密码',
    confirmReset: '确认重置',
    selectRole: '选择角色',
    enterEmail: '请输入邮箱',
    enterPhone: '请输入手机号',
    passwordRule: '请输入密码',
    usernameRule: '请输入用户名',
    nicknameRule: '请输入昵称',
    passwordLengthRule: '密码长度不能少于6位',
    passwordConfirmRule: '请再次输入密码',
    passwordMismatch: '两次输入密码不一致!',
    emailRule: '请输入正确的邮箱格式',
    phoneRule: '请输入正确的手机号格式',
    deleteConfirm: '确定要删除用户 {name} 吗？',
    deleteTitle: '删除确认',
    deleteSuccess: '用户删除成功',
    deleteFailed: '用户删除失败',
    createSuccess: '用户创建成功',
    createFailed: '用户创建失败',
    updateSuccess: '用户信息更新成功',
    updateFailed: '用户信息更新失败',
    roleAssignSuccess: '角色分配成功',
    roleAssignFailed: '角色分配失败',
    passwordResetSuccess: '密码重置成功',
    passwordResetFailed: '密码重置失败',
    statusChangeSuccess: '用户{action}成功',
    statusChangeFailed: '用户{action}失败',
    userLog: '用户日志',
    userLogTitle: '用户日志',
    logContainerCode: '集装箱编码',
    logOperationType: '操作类型',
    logStatusChange: '状态变更',
    logOperator: '操作人',
    logRemark: '备注',
    logOperTime: '操作时间',
    noLogData: '暂无操作日志',
    close: '关闭'
  },
  roleManagement: {
    title: '系统角色管理',
    subtitle: '管理角色与权限分配',
    addRole: '新增角色',
    searchRoleName: '搜索角色名称...',
    allStatus: '全部状态',
    normal: '正常',
    disabled: '禁用',
    query: '查询',
    reset: '重置',
    roleId: '角色ID',
    roleName: '角色名称',
    roleKey: '角色标识',
    roleSort: '排序',
    dataScope: '数据权限',
    status: '状态',
    createTime: '创建时间',
    actions: '操作',
    edit: '编辑',
    dataPermission: '数据权限',
    menuPermission: '菜单权限',
    assignUser: '分配用户',
    enable: '启用',
    disable: '禁用',
    delete: '删除',
    noData: '暂无角色数据',
    noDataTip: '点击右上角“新增角色”开始创建',
    addRoleTitle: '新增角色',
    editRoleTitle: '编辑角色',
    dataScopeTitle: '数据权限设置',
    menuPermissionTitle: '菜单权限设置',
    saveSettings: '保存设置',
    assignUserTitle: '分配用户',
    confirmAssign: '确认分配',
    dataScopeAll: '全部数据权限',
    dataScopeCustom: '自定数据权限',
    dataScopeDept: '本部门数据权限',
    dataScopeDeptAndBelow: '本部门及以下数据权限',
    dataScopeSelf: '仅本人数据权限',
    dataScopeRange: '数据权限范围',
    selectDataScope: '请选择数据权限',
    permissionSetting: '权限设置',
    enterRoleName: '请输入角色名称',
    enterRoleKey: '请输入角色标识',
    enterSort: '请输入排序',
    enterRemark: '请输入备注',
    availableUsers: '未分配用户',
    selectedUsers: '已分配用户',
    add: '分配',
    remove: '取消分配',
    searchUser: '搜索用户',
    deleteConfirm: '确定要删除角色 {name} 吗？',
    deleteTitle: '删除确认',
    deleteSuccess: '角色删除成功',
    deleteFailed: '角色删除失败',
    createSuccess: '角色创建成功',
    createFailed: '角色创建失败',
    updateSuccess: '角色信息更新成功',
    updateFailed: '角色信息更新失败',
    dataScopeSuccess: '数据权限设置成功',
    dataScopeFailed: '数据权限设置失败',
    menuPermSuccess: '菜单权限保存成功',
    menuPermFailed: '菜单权限保存失败',
    userAssignSuccess: '用户分配成功',
    userAssignFailed: '用户分配失败',
    statusChangeSuccess: '角色{action}成功',
    statusChangeFailed: '角色{action}失败',
    remark: '备注'
  },
  profile: {
    user: '用户',
    unassignedEmail: '未设置邮箱',
    unassignedPhone: '未设置手机号',
    registeredAt: '注册于',
    basicInfo: '基本信息',
    manageProfile: '管理您的个人资料',
    username: '用户名',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    personalIntro: '个人简介',
    saveChanges: '保存修改',
    enterNickname: '请输入昵称',
    enterEmail: '请输入邮箱',
    enterPhone: '请输入手机号',
    introPlaceholder: '简单介绍一下自己...',
    changePassword: '修改密码',
    securityTip: '定期更换密码以保障账户安全',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    enterOldPassword: '请输入原密码',
    enterNewPassword: '请输入新密码（至少6位）',
    confirmNewPassword: '请确认新密码',
    passwordLengthRule: '密码长度不能少于6位',
    passwordConfirmRule: '请再次输入密码',
    passwordMismatch: '两次输入密码不一致!',
    securitySettings: '安全设置',
    manageSecurity: '管理账户安全相关选项',
    loginPassword: '登录密码',
    passwordProtected: '已设置密码保护',
    edit: '修改',
    emailVerification: '邮箱验证',
    emailBound: '已绑定邮箱',
    phoneVerification: '手机验证',
    phoneBound: '已绑定手机',
    notBound: '未绑定',
    completed: '已完成',
    bind: '绑定',
    avatarUploadSuccess: '头像上传成功',
    avatarUploadFailed: '头像上传失败',
    updateSuccess: '个人信息更新成功',
    updateFailed: '个人信息更新失败',
    passwordChangeSuccess: '密码修改成功',
    passwordChangeFailed: '密码修改失败，请检查原密码是否正确',
    emailRule: '请输入正确的邮箱格式',
    phoneRule: '请输入正确的手机号格式',
    changePasswordBtn: '修改密码',
    admin: '超级管理员',
    cargo: '物流仓储专员',
    finance: '财务人员',
    warehouse: '仓库管理员',
    normalUser: '普通用户'
  },
  timelineAnalysis: {
    title: '供应链时效分析报表',
    shippingCycle: '海运在途周期',
    shippingCycleDesc: 'ATA - 装柜日期',
    customsCycle: '海关清关周期',
    customsCycleDesc: '清关完成时间 - ATA',
    deliveryDelay: '拖车调度效率（派送延时）',
    deliveryDelayDesc: '配送时间 - 清关完成时间',
    totalCycle: '全链路总周转时效',
    totalCycleDesc: '完结时间 - 装柜日期',
    days: '天',
    containerDetail: '集装箱时效明细',
    avgDays: '平均',
    minDays: '最短',
    maxDays: '最长'
  },
  storageManagement: {
    pageTitle: '入库管理',
    pageSubtitle: '确认入库',
    pendingTitle: '📦 待入库确认',
    pendingDesc: '货物人员已确认到港，等待管理员入库',
    noPendingOrders: '暂无待入库订单',
    allOrdersProcessed: '所有订单已处理',
    imagesUploaded: '📸 已上传',
    imagesNotUploaded: '📷 未上传',
    confirmStorage: '✅ 确认入库',
    confirmStorageSuccess: '✅ {containerNo} 已确认入库',
    completedTitle: '📋 已入库记录',
    orderCount: '{count} 单',
    noCompletedRecords: '暂无已入库记录',
    table: {
      containerNo: '单号',
      originPort: '起运港',
      destinationPort: '目的港',
      receivingCompany: '收货公司',
      actualArrival: '实际到港',
      deliveryTime: '配送时间',
      containerImages: '货柜图片',
      actions: '操作',
      status: '状态'
    }
  },
  skuTable: {
    noItems: '暂无商品明细，点击下方按钮添加'
  },
  common: {
    search: '搜索',
    allStatus: '全部状态',
    noData: '暂无数据',
    total: '共',
    items: '条',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    process: '处理',
    upload: '上传',
    logout: '退出登录',
    welcome: '欢迎回来',
    logoutSuccess: '已退出登录',
    success: '操作成功',
    error: '操作失败',
    warning: '请注意',
    readOnly: '只读',
    cargoRole: '巴西物流专员',
    adminRole: '管理员',
    noPermission: '无权限访问此页面',
    locked: '数据已锁定（已完结归档）',
    back: '返回',
    export: '导出',
    refresh: '刷新',
    loading: '加载中...',
    searchPlaceholder: '请输入柜号',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    tips: '提示'
  }
}
